export default __webpack_public_path__ + "warning-icon.45e0edbefe4bbce07e07075cb2876f5f.svg";